import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import cn from 'classnames'

import Button from 'app/components/ButtonDefault'
import FireStreakLabel from 'app/domains/common/FireStreakLabel'
import UserProtrackDoneCommitDetailsContainer from './UserProtrackDoneCommitDetails'
import ModalBody from 'app/components/Modal/ModalBody'
import YouAreAwesome320 from 'app/components/SVGS/youAreAwesome320'
import YouAreAwesome from 'app/components/SVGS/youAreAwesome'
import { getDimensions } from 'helpers/multibrowserHelper'
import './styles.scss'

const bc = 'user-protrack-congratulations-popup'

class UserCongratulationsPopup extends Component {
  static propTypes = {
    isPostSurveyLink: PropTypes.bool,
    activeProTrackLevel: PropTypes.shape({
      name: PropTypes.string,
    }),
    userName: PropTypes.string,
    streakCurrent: PropTypes.number,
    onRequestClose: PropTypes.func.isRequired,
    requestSurvey: PropTypes.func.isRequired,
    showTypeFormPopup: PropTypes.func.isRequired,
    handleCloseModal: PropTypes.func.isRequired,
  }

  maybeLaterHandler = () => {
    this.props.requestSurvey(true)
  }

  render() {
    const {
      t,
      i18n: { language },
      isPostSurveyLink,
      onRequestClose,
      userName,
      activeProTrackLevel,
      showTypeFormPopup,
      isPostTrackSurveyEnabled,
      handleCloseModal,
    } = this.props
    const { width } = getDimensions()
    const streakMax = activeProTrackLevel.get('streakMax')
    const completedCount = activeProTrackLevel.get('completedCount')
    return (
      <ModalBody onRequestClose={onRequestClose} withoutCross>
        <div className={`${bc}__row`}>{width > 580 ? <YouAreAwesome /> : <YouAreAwesome320 />}</div>
        <div className={`${bc}__row`}>
          <div className={`${bc}__title`}>{t('Congratulations', { userName })}</div>
          <div className={`${bc}__substring`}>
            {t('You have reached the end of')}{' '}
            {`${activeProTrackLevel.get('proTrackName')} (${activeProTrackLevel.get('name')})`}
          </div>
        </div>
        <div className={`${bc}__row`}>
          <div className={`${bc}__body`}>
            <UserProtrackDoneCommitDetailsContainer
              streakMax={streakMax}
              animate={() => ({
                completedCount: {
                  from: 0,
                  to: completedCount,
                  duration: 1200,
                  int: true,
                  easing: 'in-sine',
                },
              })}
              completedCount={completedCount}
            />
            {streakMax > 0 && (
              <div className={`${bc}__streak`}>
                <FireStreakLabel
                  animate={{
                    streakMax: {
                      from: 0,
                      to: streakMax,
                      duration: 1200,
                      easing: 'in-sine',
                      int: true,
                    },
                  }}
                  streakMax={streakMax}
                  radiusCircle={70}
                  fireHeight={35}
                />
              </div>
            )}
          </div>
        </div>
        {isPostTrackSurveyEnabled ? (
          <div>
            <div className={`${bc}__row`}>
              <span className={`${bc}__question`}>
                {t('Please take a moment to reflect on your experience with')}{' '}
                <span className={`${bc}__block`}>
                  {activeProTrackLevel.get('proTrackName')} - {activeProTrackLevel.get('name')}
                </span>
              </span>
            </div>
            <div className={`${bc}__row`}>
              <div className={`${bc}__buttons`}>
                {isPostSurveyLink && (
                  <Button
                    lg
                    primary
                    onClick={showTypeFormPopup}
                    className={cn(`${bc}__button`, {
                      [`${bc}__button__${language}`]: language,
                    })}
                  >
                    {t('Next')}
                  </Button>
                )}
                <Button lg onClick={this.maybeLaterHandler} className={`${bc}__button`}>
                  {t('Maybe Later')}
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              lg
              primary
              onClick={handleCloseModal}
              className={cn(`${bc}__button`, {
                [`${bc}__button__${language}`]: language,
              })}
            >
              {t('Ok')}
            </Button>
          </div>
        )}
      </ModalBody>
    )
  }
}

export default withTranslation('user')(UserCongratulationsPopup)
